import { useMemo } from 'react';
import { Box, Center, Column, Row, Typography } from '@tempmee/react';
import { colors, shadows } from '@tempmee/tailwind';
import { ConfirmPopup, Divider, Pressable } from '~/commonComponents';
import { useToggle } from '~/hooks';
import { useUserSelector } from '~/hooks/useUserSelector';
import BestInDentalBadge from '~/images/best-in-dental.png';
import LogoDarkFull from '~/images/logos/logoDarkFull.svg';

export const BestInDentalWinner = () => {
  const currentUser = useUserSelector();
  const [isOpen, controls] = useToggle();

  const isWinning = useMemo(() => {
    return currentUser?.office_info?.bestInDental?.status === 'winner';
  }, [currentUser]);

  const winningYear = useMemo(() => {
    if (!isWinning) {
      return null;
    }

    const bestInDental = currentUser?.office_info?.bestInDental;

    if (bestInDental?.winnerDetails?.length === 0) {
      return null;
    }

    return currentUser?.office_info?.bestInDental?.winnerDetails?.[0]?.winningYear;
  }, [currentUser, isWinning]);

  if (!isWinning) {
    return null;
  }

  return (
    <>
      <Divider width={1 as any} height={'50%' as any} />
      <Pressable onPress={() => controls.setOn()}>
        <Row
          width="214px"
          height="104px"
          align="center"
          justify="center"
          gap={1}
          style={{
            borderRadius: 14,
            backgroundColor: '#F4FCFF',
            boxShadow: shadows['elevation-1'],
          }}
        >
          <Center width="92px" height="82px">
            <img
              alt="Best In Dental Badge"
              src={BestInDentalBadge}
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </Center>
          <Column>
            <Box width="62px" height="30px" style={{ marginBottom: 8 }}>
              <img
                alt="GoTu Logo"
                src={LogoDarkFull}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </Box>
            <Typography size="heading_3" bold color="#6ACE85">
              {winningYear}
            </Typography>
            <Typography size="heading_3" bold color="#1D739F">
              Winner
            </Typography>
          </Column>
        </Row>
      </Pressable>
      {isOpen && (
        // @ts-expect-error - ConfirmPopup still written in JavaScript
        <ConfirmPopup
          modalStyle={{ maxWidth: 500, maxHeight: 520, paddingTop: 57 }}
          Icon={() => (
            <img alt="Best In Dental Badge" src={BestInDentalBadge} width={150} height={170} />
          )}
          title="This Office is one of GoTu’s Best In Dental"
          titleStyle={{ marginBlock: 16 }}
          description={
            <Column>
              <Typography color={colors.neutral[500]}>
                You’ve been recognized for consistently providing a standout experience to GoTu
                professionals, from smooth workflows to great communication. The feedback from pros
                speaks for itself, and they keep coming back.
              </Typography>
              <Typography color={colors.neutral[500]} style={{ marginTop: 16 }}>
                Your reputation is well-earned
              </Typography>
            </Column>
          }
          descriptionStyle={{ marginBottom: 32, width: '100%' }}
          rightButtonText="Got it!"
          rightButtonAction={controls.setOff}
        />
      )}
    </>
  );
};
